<template>
  <div class="h-100">
    <h1 class="display-3">{{template.name}}</h1>

    <v-divider></v-divider>

    <v-container fluid>
      <v-row>
        <v-col cols="12" md="6">
          <b-form-input
            label="Collection Code"
            v-model="collectionCode"
            list="cc-list"
            @keypress.enter="search()"
            @click:append="search()"
          ></b-form-input>

            <datalist id="cc-list">
                <option v-for="cCode in collectionCodes" :key="cCode">{{ cCode }}</option>
            </datalist>

        </v-col>
        <v-col cols="12" md="6">
          <v-row>
            <v-col md="auto">
              <b-btn
                variant="success"
                block
                @click="switchTemplate('ento_its2')"
              >{{ template.id == 'ento_its2' ? 'refresh' : 'Anoph-Individual'}}</b-btn>
            </v-col>
            <v-col md="auto">
              <b-btn
                variant="warning"
                block
                @click="switchTemplate('pcr')"
              >{{ template.id == 'pcr' ? 'refresh' : 'SpeciesID'}}</b-btn>
            </v-col>
            <v-col md="auto">
              <b-btn
                variant="info"
                block
                @click="switchTemplate('kdr')"
              >{{ template.id == 'kdr' ? 'refresh' : 'ELISA-Results'}}</b-btn>
            </v-col>
            <v-col md="auto">
              <b-btn
                variant="secondary"
                block
                @click="switchTemplate('other')"
              >{{ template.id == 'other' ? 'refresh' : 'Other'}}</b-btn>
            </v-col>
            <v-col md="auto">
              <b-btn
                variant="danger"
                block
                @click="switchTemplate('deleted')"
              >{{ template.id == 'deleted' ? 'refresh' : 'Deleted'}}</b-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <div>
      <b-alert v-model="save_message" variant="success" class="mb-4">{{save_message}}</b-alert>

      <b-alert v-model="error_message" variant="error" class="mb-4">{{error_message}}</b-alert>
    </div>

    <hot-table
      ref="hotTableComponent"
      :settings="settings"
      licenseKey="non-commercial-and-evaluation"
      width="100%"
    ></hot-table>
  </div>
</template>

<script>
import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { HotTable } from "@handsontable/vue";

import { mapState, mapGetters, mapActions } from "vuex";
import * as _ from "lodash";

import { HTTP } from "@/utilities/http-common";

export default {
  components: {
    HotTable
  },
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      save_message: null,
      error_message: null,
      data: [],
      settings: {
        data: [],
        stretchH: "all",
        rowHeaders: true,
        colHeaders: [],
        columns: [],
        comments: true,
        licenseKey: "non-commercial-and-evaluation"
      },
      template: {},
      columns: {},
      dirty: false, // If there is unsaved data in this view.
      periods: ["F01", "F02", "F03"],
      period: null,
      collectionCode: null,
      templateIDs: [
        "ento_its2",
        "microscopy",
        "pcr",
        "kdr",
        "other",
        "deleted"
      ],
      colIds: [],
      collectionCodes: []
    };
  },
  computed: {
    ...mapState("websheet", ["templates"]),
    ...mapGetters("websheet", ["getTemplateById"])
  },
  mounted() {
      const that = this;

    this.collectionCode = this.$route.query.collectionCode ? this.$route.query.collectionCode : "";
    let templateId = this.$route.params.templateId ? this.$route.params.templateId : "microscopy";
    if (this.templates.length) {
      this.initWebsheet(templateId);
    } else {
      this.getTemplates().then(response => {
        this.setTemplates(response.data);
        this.initWebsheet(templateId);
      });
    }

    that.getEntoCollectionCodes().then(response => {
      _.each(response.data, function(item, index) {
        item.group_collection_code = item.group_collection_code_indoors ? item.group_collection_code_indoors : item.group_collection_code_outoors;
          that.collectionCodes.push(item.group_collection_code);
      });
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
    ...mapActions(["setAlert"]),
    ...mapActions("websheet", ["getTemplates", "setTemplates", "getEntoData", "getEntoCollectionCodes"]),
    save: function() {
      this.dirty = false;
    },
    search: function() {
      let that = this;
      that.settings.data = [];

      if (!that.collectionCode.trim()) {
        return;
      }

      that.getEntoData(that.collectionCode).then(response => {
        let data = [];

        if (that.template.id === "deleted") {
          _.each(response.data, function(item) {
            if (item.deleted) {
              item.deleted = "Yes";
              data.push(item);
            }
          });
        } else if (that.template.id === "other") {
          _.each(response.data, function(item) {
            if (
              !item.deleted &&
              (item.pcr_anoph_species_molecular === "Other" ||
                item.pcr_anoph_species_molecular === "Culex")
            ) {
              item.deleted = "Yes";
              data.push(item);
            }
          });
        } else {
          _.each(response.data, function(item) {
            if (
              !item.deleted &&
              (item.pcr_anoph_species_molecular !== "Other" &&
                item.pcr_anoph_species_molecular !== "Culex")
            ) {
              item.deleted = "No";
              data.push(item);
            }
          });
        }

        that.settings.data = data;
      });
    },
    switchTemplate: function(templateId) {
      this.initWebsheet(templateId);
    },
    initWebsheet(templateId) {
      let that = this;

      this.template = this.getTemplateById(templateId);
      if (!this.template) {
        this.setAlert({
          message: "Please select a template.",
          type: "error"
        });
        return this.$router.push({
          name: "websheet-templates"
        });
      }

      that.settings.data = []; // Clear the current data.
      that.settings.colHeaders = [];
      that.colIds = [];
      that.settings.colHeaders = _.map(that.template.columns, item => {
        let display = item.name ? item.name : item.id;
        // let display = item.id;
        that.colIds.push(item.id);
        return display;
      });

      that.settings.columns = [];

      // var data = {};
      _.each(that.template.columns, function(item) {
        // data[item.name] = null;

        // var col_id = item.name ? item.name : item.id;
        var col = {
          data: item.id,
          type: item.type
        };

        // Dropdown.
        if (item.values.length) {
          col.type = "dropdown";
          col.source = item.values;
        }

        // Readonly
        if (
          (that.template.id == "ento_its2" || that.template.id == "other") &&
          item.id == "mosquito_code"
        ) {
          col.readOnly = false;
        } else {
          col.readOnly = item.readonly;
        }

        that.settings.columns.push(col);
      });

      that.$refs.hotTableComponent.hotInstance.updateSettings({
        afterChange: function(changes, source) {
          if (source == "loadData") {
            return;
          }

          changes.forEach(([row, prop, oldValue, newValue]) => {
            let col = that.colIds.indexOf(prop);

            const commentsPlugin = that.$refs.hotTableComponent.hotInstance.getPlugin(
              "comments"
            );
            commentsPlugin.removeCommentAtCell(row, col);

            const post_data = {};
            const row_data = that.settings.data[row];
            post_data[prop] = newValue;

            HTTP.put("/kenya/update-ento-data/" + row_data.id, post_data)
              .then(() => {})
              .catch(error => {
                that.$refs.hotTableComponent.hotInstance.setCellMeta(
                  row,
                  col,
                  "valid",
                  false
                );
                commentsPlugin.setCommentAtCell(
                  row,
                  col,
                  error.response.data[prop]
                );
                commentsPlugin.showAtCell(row, col);
                that.$refs.hotTableComponent.hotInstance.render();
              });
          });
        }
        // beforeChange: function(changes, source) {
        //     if (source == "loadData") {
        //         return;
        //     }

        //     changes.forEach(([row, prop, oldValue, newValue]) => {
        //         let col = that.settings.colHeaders.indexOf(prop);

        //         const commentsPlugin = that.$refs.hotTableComponent.hotInstance.getPlugin('comments');
        //         commentsPlugin.removeCommentAtCell(row, col);

        //         const post_data = {};
        //         const row_data = that.settings.data[row];
        //         post_data[prop] = newValue;

        //         HTTP.put('/kenya/update-ento-data/' + row_data.id, post_data).then(response => {
        //             ;
        //         }).catch(error => {
        //             that.$refs.hotTableComponent.hotInstance.setCellMeta(row, col, 'valid', false);
        //             commentsPlugin.setCommentAtCell(row, col, error.response.data[prop]);
        //             commentsPlugin.showAtCell(row, col);
        //             that.$refs.hotTableComponent.hotInstance.render();
        //         });
        //     });
        // }
      });

      that.search();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.dirty) {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }
};
</script>

<style>
@import "~handsontable/dist/handsontable.full.css";

.ht {
  width: 100%;
}
</style>
